






































































import { Component, Prop, Vue } from "vue-property-decorator";
import { positivePass, pricePass } from "@/utils/rules";
import { classroomAddApi, classroomEditApi } from "@/api/classRoom";
import eventBus from "@/utils/bus";
@Component({
  components: {},
})
export default class extends Vue {
  @Prop() editInfo?: any;
  ruleForm = {
    className: "",
    classPeople: "",
    remark: "",
  };
  rules = {
    className: [
      {
        required: true,
        message: "请输入教室名称",
        trigger: "blur",
      },
    ],
    classPeople: [
      {
        required: true,
        message: "请输入教室人数",
        trigger: "blur",
      },
      { validator: positivePass, trigger: "blur" },
    ],
  };
  created() {
    if (this.editInfo) {
      this.ruleForm.className = this.editInfo.name;
      this.ruleForm.classPeople = this.editInfo.people;
      this.ruleForm.remark = this.editInfo.remark;
    }
  }
  hideAddClassDialog() {
    this.$emit("update:visible", false);
  }
  saveContent() {
    this.$message({
      message: "保存完毕",
      type: "success",
    });
    this.hideAddClassDialog();
    eventBus.$emit("initClassRoomManagement");
  }
  handleAddClassSubmit() {
    (this.$refs["ruleFormDom"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          const option = { ...this.ruleForm };
          if (this.editInfo == "") {
            classroomAddApi({
              name: option.className,
              people: Number(option.classPeople),
              remark: option.remark,
            }).then((res: any) => {
              if (res.error_code === 0) {
                this.saveContent();
                this.$emit("addClassRoomId", res.data.classroom_id);
              }
            });
          } else if (this.editInfo) {
            classroomEditApi({
              name: option.className,
              people: Number(option.classPeople),
              remark: option.remark,
              classroom_id: this.editInfo.classroom_id,
            }).then((res: any) => {
              if (res.error_code === 0) {
                this.saveContent();
              }
            });
          }
        }
      }
    );
  }
}
